import { atom } from 'recoil';
import { NotificationT } from 'types/notification';

export const notificationListState = atom<NotificationT[]>({
  key: 'notification'
});
